import React from 'react';
import { Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

//todo: have page size options drop upwards(?)
class CDIReviewTable extends React.Component {
    constructor(props) {
        super(props);
        const processedResults = this.addUniqueKey(this.props.searchResults);
        this.state = {
            processedResults,
            selected: this.getSelected(processedResults),
        }
    };


    addUniqueKey = (rows) => {
        return rows.map((row, index) => ({
            ...row,
            uniqueKey: `${row.alertID}-${index}`
        }));
    };

    componentWillReceiveProps(nextProps) {
        //update selected state on initial load and startQueue calls
        if (nextProps.searchResults.length > 0 && nextProps.refreshSelected) {
            this.setState({ selected: this.getSelected(nextProps.searchResults) });
            const processed = this.addUniqueKey(this.props.searchResults);
            this.setState({
                processedResults: processed,
                selected: this.getSelected(processed)
            });
            this.props.toggleRefreshSelected();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchResults !== this.props.searchResults) {
            const processed = this.addUniqueKey(this.props.searchResults);
            this.setState({
                processedResults: processed,
                selected: this.getSelected(processed)
            });
        }
    }

    getSelected = (searchResults = this.state.processedResults) => {
        return searchResults ? searchResults.filter(x => x.selected).map(x => x.uniqueKey) : [];
    }

    onRowSelect = ({ uniqueKey }, isSelected) => {
        const records = [...this.state.processedResults];
        const target = records.find(x => x.uniqueKey === uniqueKey);
        if (target) {
            target.selected = isSelected;
            this.props.updateAlertQueue(target.cdiAlertWorkflowID, isSelected);
        }

        this.setState({
            selected: this.getSelected(records),
            processedResults: records
        });

        this.props.handleSetSearchResults(records);
    };

    //todo: consider making a batch version of updateAlertQueue
    onSelectAll = (isSelected, rows) => {
        const records = [...this.state.processedResults];
        rows.forEach(row => {
            const target = records.find(r => r.uniqueKey === row.uniqueKey);
            if (target) {
                target.selected = isSelected;
                this.props.updateAlertQueue(target.cdiAlertWorkflowID, isSelected);
            }
        });

        this.setState({
            selected: this.getSelected(records),
            processedResults: records
        });

        this.props.handleSetSearchResults(records);
    };

    formatDate = (cell) => {
        return cell ? cell.split('T')[0] : '';
    }

    //todo: replace with icon / add icon?
    formatActions = (cell, row) => {
        return (
            <Button disabled={row.cdiAlertWorkflowStatusID=="200"} onClick={() => this.props.startAlertReview(row)}>Start Review</Button>
        )
    }

    render() {
        const options = {
            page: this.props.page,
            sizePerPage: this.props.sizePerPage,
            onPageChange: this.props.onPageChange,
            onSortChange: this.props.onSortChange
        };

        const nonSelectableRows = this.state.processedResults
            .filter(row => String(row.cdiAlertWorkflowStatusID) === "200").map(row => row.uniqueKey);

        const selectRowProp = {
            mode: 'checkbox',
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll,
            selected: this.state.selected,
            unselectable: nonSelectableRows,
        };

        return (
            <div style={{ marginTop: '4rem' }}>
                <BootstrapTable ref="alertReviewTable" data={this.state.processedResults} options={options} selectRow={selectRowProp}
                    hover pagination remote fetchInfo={{ dataTotalSize: this.props.totalItems }}>
                    <TableHeaderColumn dataField="uniqueKey" isKey hidden>Unique Key</TableHeaderColumn>
                    <TableHeaderColumn dataField="alertID"  dataSort>Alert ID</TableHeaderColumn>
                    <TableHeaderColumn dataField="memberID" dataSort>Member ID</TableHeaderColumn>
                    <TableHeaderColumn dataField="memberName" dataSort>Member Name</TableHeaderColumn>
                    <TableHeaderColumn dataField="practiceDesc" dataSort>Practice</TableHeaderColumn>
                    <TableHeaderColumn dataField="providerID" dataSort>Provider ID</TableHeaderColumn>
                    <TableHeaderColumn dataField="providerName" dataSort>Provider Name</TableHeaderColumn>
                    <TableHeaderColumn dataField="appointmentDate" dataSort dataFormat={this.formatDate}>Appt. Date</TableHeaderColumn>
                    <TableHeaderColumn dataField="cdiReceivedDate" dataSort dataFormat={this.formatDate}>Captured Date</TableHeaderColumn>
                    <TableHeaderColumn dataField="createdByFullName" dataSort>PEC</TableHeaderColumn>
                    <TableHeaderColumn dataField="queryCreated" dataSort dataFormat={this.formatDate}>Query Created</TableHeaderColumn>
                    <TableHeaderColumn dataField="cdiAlertStatusDesc" dataSort>Status</TableHeaderColumn>
                    <TableHeaderColumn dataField="action" dataFormat={this.formatActions}>Action</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default CDIReviewTable;